import axios from 'axios';

// Create axios instance
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 90000,
    // headers: {
    //     'Content-Type': 'application/json',
    // }
});

// Queue untuk menampung request yang gagal saat token sedang di-refresh
let isRefreshing = false;
let failedQueue = [];

// Fungsi untuk memproses queue request yang tertunda
const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

// Fungsi untuk refresh token
const refreshToken = async () => {
    const currentToken = localStorage.getItem('token');
    if (!currentToken) {
        throw new Error('No token available');
    }

    const isitoken = `Bearer ${currentToken}`;
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/refresh`,
        headers: { 
            'Authorization': isitoken
        },
        withCredentials: true,
    };

    const response = await axios.request(config);
    
    if (response.data.results && response.data.results.access_token) {
        const newToken = response.data.results.access_token;
        localStorage.setItem('token', newToken);
        return newToken;
    } else {
        throw new Error('No new token received');
    }
};

// Request Interceptor - Menambahkan token ke setiap request
apiClient.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response Interceptor - Handle 401 errors (Token Expired)
apiClient.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        // Jika error 401 (Unauthorized) dan belum dicoba refresh
        if (error.response?.status === 401 && !originalRequest._retry) {
            // Tandai request ini sudah dicoba refresh
            originalRequest._retry = true;

            // Jika sedang dalam proses refresh, tambahkan ke queue dan tunggu
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                .then(token => {
                    // Update header dengan token baru dan retry request
                    originalRequest.headers['Authorization'] = `Bearer ${token}`;
                    return apiClient(originalRequest);
                })
                .catch(err => {
                    return Promise.reject(err);
                });
            }

            // Mulai proses refresh token
            isRefreshing = true;

            try {
                // Panggil refresh token API
                const newToken = await refreshToken();
                
                // Proses semua request yang tertunda di queue dengan token baru
                processQueue(null, newToken);
                
                // Update header original request dengan token baru
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                
                // Retry original request dengan token baru
                return apiClient(originalRequest);
            } catch (refreshError) {
                // Refresh token gagal, reject semua request di queue
                processQueue(refreshError, null);
                
                // Clear token dari localStorage
                localStorage.removeItem('token');
                
                // Redirect ke login
                window.location.href = '/auth';
                
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        // Jika bukan 401 atau sudah pernah di-retry, reject error biasa
        return Promise.reject(error);
    }
);

export default apiClient;